function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Sans"
    },
    d: "M 2 5 L 2 6 L 2 25 L 2 26 L 3 26 L 6 26 L 6 27 L 10 27 L 10 26 L 22 26 L 22 27 L 26 27 L 26 26 L 29 26 L 30 26 L 30 25 L 30 8 L 30 7 L 29 7 L 17 7 L 17 6 L 17 5 L 16 5 L 3 5 L 2 5 z M 4 7 L 15 7 L 15 8 L 15 9 L 16 9 L 28 9 L 28 24 L 26 24 L 26 23 L 22 23 L 22 24 L 10 24 L 10 23 L 6 23 L 6 24 L 4 24 L 4 7 z M 11 11 C 9.3549901 11 8 12.354991 8 14 C 8 14.956766 8.4490523 15.82398 9.15625 16.375 C 7.3158167 17.114768 6 18.903494 6 21 L 8 21 C 8 19.331516 9.3315161 18 11 18 C 12.668484 18 14 19.331516 14 21 L 16 21 C 16 18.903494 14.684183 17.114768 12.84375 16.375 C 13.550948 15.82398 14 14.956767 14 14 C 14 12.35499 12.64501 11 11 11 z M 11 13 C 11.564128 13 12 13.435872 12 14 C 12 14.564128 11.564128 15 11 15 C 10.435871 15 10 14.564129 10 14 C 10 13.435871 10.435871 13 11 13 z M 18 13 L 18 15 L 26 15 L 26 13 L 18 13 z M 18 17 L 18 19 L 26 19 L 26 17 L 18 17 z"
  }));
};

export default __webpack_public_path__ + "static/media/contact-card.48c97d17.svg";
export { SvgComponent as ReactComponent };